// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b1944da1252383fd72bf4149d3cc375a76da92da';
export const BUILD_NUMBER = '193';
export const BUILD_TIMESTAMP = '2026-07-13T01:57:25.848Z';
